// @flow
import * as React from 'react';

type Props = {
  type: string,
  className?: string,
  fill?: string | null,
  width?: string | number | null,
  height?: string | number | null,
  style?: Object | null,
  onClick?: Function,
};

function Icon({ type, className, width, height, fill, style, onClick }: Props) {
  const styles = { fill, color: fill, ...style };
  return (
    <svg
      onClick={onClick}
      className={className}
      width={width}
      height={height || width}
      style={styles}
    >
      <use xlinkHref={`#icon-${type}`} />
    </svg>
  );
}

Icon.defaultProps = {
  className: undefined,
  fill: null,
  width: '1em',
  height: null,
  style: null,
  onClick: () => {},
};

export default Icon;



// WEBPACK FOOTER //
// ./app/components/shared/Icons/Icon/index.js